import { MotifButton, MotifCardFooter, MotifFormField, MotifInput, MotifOption, MotifSelect, MotifTextArea } from '@ey-xd/motif-react'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'

function UserGroupForm(props) {
    const { onFormSubmit, onCancel, data } = props;
    const { control, setValue, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            groupName: '',
            domain: 'Cyber',
            location: 'America',
            status: 'Active',
            description: ''
        }
    });
    useEffect(()=> {
        if(data) {
            setValue("groupName", data?.groupName)
            setValue("domain", data?.groupDomain)
            setValue("location", data?.groupLocation)
            setValue("status", data?.groupStatus)
            setValue("description", data?.groupDescription)

        }
    })
    const onSubmit = (data) => {
        onFormSubmit(data);
    };
  return (
    <div>
        <div className='flex flex-col'>
            <div className="flex gap-3 mb-3 !w-full">
                {/* <div> */}
                    <div className='w-3/12'>
                        <MotifFormField label="group name">
                            <Controller
                                name="groupName"
                                control={control}
                                render={({ field }) => (
                                    <MotifInput hideClearButton {...field} placeholder="Group name" />
                                )}
                            />
                        </MotifFormField>
                    </div>
                    <div className="w-3/12">
                        <MotifFormField label="domain">
                            <Controller
                                name="domain"
                                control={control}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select domain" visibleOptions={3}>
                                        {/* <MotifOption value="">Select Domain</MotifOption> */}
                                        <MotifOption value="Cyber">Cyber</MotifOption>
                                        <MotifOption value="Risk">Risk</MotifOption>
                                        <MotifOption value="SAP">SAP</MotifOption>
                                        <MotifOption value="ESG">ESG</MotifOption>
                                    </MotifSelect>
                                )}
                            />
                        </MotifFormField>
                    </div>
                    <div className="w-3/12">
                        <MotifFormField label="location">
                            <Controller
                                name="location"
                                control={control}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select location" visibleOptions={3}>
                                        {/* <MotifOption value="">Select Location</MotifOption> */}
                                        <MotifOption value="America">America</MotifOption>
                                        <MotifOption value="India">India</MotifOption>
                                        <MotifOption value="Delhi">Delhi</MotifOption>
                                        <MotifOption value="Europe">Europe</MotifOption>
                                    </MotifSelect>
                                )}
                            />
                        </MotifFormField>
                    </div>
                    <div className="w-3/12">
                        <MotifFormField label="Status">
                            <Controller
                                name="status"
                                control={control}
                                render={({ field }) => (
                                    <MotifSelect {...field} placeholder="Select status" visibleOptions={3}>
                                        <MotifOption value="Active">Active</MotifOption>
                                        <MotifOption value="Inactive">Inactive</MotifOption>
                                    </MotifSelect>
                                )}
                            />
                        </MotifFormField>
                    </div>
                {/* </div> */}

            </div>
                    <div className="w-full">
                        <div>
                            <MotifFormField label="Description">
                                <Controller
                                    name="description"
                                    control={control}
                                    render={({ field }) => (
                                        <MotifTextArea {...field} placeholder="Enter description" />
                                    )}
                                />
                            </MotifFormField>
                        </div>
                    </div>
            <hr style={{ opacity: "0.1" }} />
            <MotifCardFooter className="justify-end">
                <MotifButton
                    onClick={onCancel}
                    type="button"
                    variant="secondary"
                    size="small"
                    className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                >
                    Cancel
                </MotifButton>
                <MotifButton
                    type="submit"
                    variant="primary"
                    size="small"
                    onClick={handleSubmit(onSubmit) as any}
                    className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
                >
                    Save
                </MotifButton>
            </MotifCardFooter>
        </div>
    </div>
  )
}

export default UserGroupForm